
import {Component, Prop, Vue} from 'vue-property-decorator';
import {commitAddNotification} from '@/store/main/mutations';
import {IPermission} from "@/interfaces/permission";
import VuePerfectScrollbar from "vue-perfect-scrollbar";

@Component({
    components: {VuePerfectScrollbar}
})
export default class ShowPermissionsDialog extends Vue {
  @Prop()
  public objData!: any;

  private dialog: boolean = false;

  get scrollSettings() {
    return {
      maxScrollbarLength: 120,
    };
  }

  get permissions(): (IPermission)[] {
    return this.objData?.all_permissions || this.objData?.permissions || []
  }

  get permissionOwner(): string {
    return this.objData?.name || this.objData?.fullname
  }
}
